// extracted by mini-css-extract-plugin
export var page = "page-module--page--15bid";